import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import isNumber from 'lodash/isNumber';
import {
  getVehicleMakesWithImage
} from '../../../core/api/getVehicleMakesWithImage';
import {
  getVehicleModelsSortedByModelName
} from '../../../core/api/getVehicleModelsSortedByModelName';
import {
  getVehicleModelsWithImage
} from '../../../core/api/getVehicleModelsWithImage';
import { getVehicleTrims } from '../../../core/api/getVehicleTrims';
import { cleanValue } from '../../../utilities/Currency';
import { getNumberFormatter } from '../../../utilities/getNumberFormatter';
import { isNonEmptyString } from '../../../utilities/isNonEmptyString';
import { defaultList } from '../../../values/vehicle';
import VehiclePlaceholder from 'Images/vehicle/vehiclePlaceholder.png';

export const PAYOFF_AMOUNT_LOWER_LIMIT = 10000;
export const PAYOFF_AMOUNT_UPPER_LIMIT = 100000;

const currencyFormatter = getNumberFormatter();

const isPayoffAmountConfirmationRequired = (payoffAmount = 0) =>
  isNumber(payoffAmount) &&
  (
    payoffAmount < PAYOFF_AMOUNT_LOWER_LIMIT ||
    payoffAmount > PAYOFF_AMOUNT_UPPER_LIMIT
  );

export const getters = {
  getVehicleMakesFunction: () => getVehicleMakesWithImage(),
  getVehicleModelsFunction: () => getVehicleModelsSortedByModelName(),
  getVehicleModelsWithImageFunction: () => getVehicleModelsWithImage(),
  getVehicleTrimsFunction: () => getVehicleTrims(),
  hasLoadedMakes: state => !isEmpty(state.makes),
  hasLoadedModels: state => !isEmpty(state.models),
  hasLoadedYears: state => !isEmpty(state.years),
  hasModelsAndImagesRequestsFinished:
    state => state.hasModelsRequestFinished && state.hasModelImagesRequestFinished,
  hasModelsRequestFinished: state => state.hasModelsRequestFinished,
  hasModelImagesRequestFinished: state => state.hasModelImagesRequestFinished,
  makeId: state => get(state, 'make.id', null),
  makeImageUrl: state => {
    const imageUrl = get(state, 'make.image_url', '');
    return isNonEmptyString(imageUrl) ? imageUrl : VehiclePlaceholder;
  },
  makeName: state => get(state, 'make.name', null),
  makes: state => isEmpty(state.makes) ? defaultList : state.makes,
  payoffAmountAsString: state => {
    return currencyFormatter(state.payoffAmount);
  },
  payoffAmountAsNumber: state => state.payoffAmount,
  payoffAmountConfirmed: state => state.payoffAmountConfirmed,
  payoffAmountConfirmedValue: state => state.payoffAmountConfirmedValue,
  payoffAmountMatchesConfirmedValue: (state, { payoffAmountAsNumber, payoffAmountConfirmedValue }) =>
    payoffAmountAsNumber === payoffAmountConfirmedValue,
  payoffAmountConfirmationRequired: (state, { payoffAmountAsNumber }) =>
    isPayoffAmountConfirmationRequired(payoffAmountAsNumber),
  mileage: state => state.mileage,
  mileageAsNumber: state => {
    const mileage = cleanValue(state.mileage);
    return isFinite(mileage) ? Number(mileage) : 0;
  },
  modelId: state => get(state, 'model.id', null),
  modelImageUrl: state => {
    const imageUrl = get(state, 'model.image_url', '');
    return isNonEmptyString(imageUrl) ? imageUrl : VehiclePlaceholder;
  },
  modelName: state => get(state, 'model.name', null),
  models: state => isEmpty(state.models) ? defaultList : state.models,
  trimName: state => get(state, 'trim.name', null),
  trims: state => state.trims,
  year: state => state.year,
  years: state => state.years
};
